import React from 'react';
import { useTranslation } from 'react-i18next';
import '../Checkout.css';

export interface BillingAddress {
  sameAsShipping: boolean;
  firstName: string;
  lastName: string;
  address: string;
  apartment: string;
  city: string;
  state: string;
  zipCode: string;
  country: string;
}

interface BillingSectionProps {
  billingAddress: BillingAddress;
  errors: { [key: string]: string };
  onBillingChange: (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => void;
}

const BillingSection: React.FC<BillingSectionProps> = ({
  billingAddress,
  errors,
  onBillingChange
}) => {
  const { t } = useTranslation();

  return (
    <div className="checkout-step">
      <h2>{t('checkout.billingAddress')}</h2>
      
      <div className="form-group">
        <label className="checkbox-label">
          <input
            type="checkbox"
            name="sameAsShipping"
            checked={billingAddress.sameAsShipping}
            onChange={onBillingChange}
          />
          <span>{t('checkout.sameAsShipping')}</span>
        </label>
      </div>

      {!billingAddress.sameAsShipping && (
        <>
          <div className="form-row">
            <div className="form-group">
              <label htmlFor="billingFirstName">{t('checkout.firstName')} *</label>
              <input
                type="text"
                id="billingFirstName"
                name="firstName"
                value={billingAddress.firstName}
                onChange={onBillingChange}
                className={errors.billingFirstName ? 'error' : ''}
                placeholder={t('checkout.enterFirstName')}
              />
              {errors.billingFirstName && <span className="error-message">{errors.billingFirstName}</span>}
            </div>
            <div className="form-group">
              <label htmlFor="billingLastName">{t('checkout.lastName')} *</label>
              <input
                type="text"
                id="billingLastName"
                name="lastName"
                value={billingAddress.lastName}
                onChange={onBillingChange}
                className={errors.billingLastName ? 'error' : ''}
                placeholder={t('checkout.enterLastName')}
              />
              {errors.billingLastName && <span className="error-message">{errors.billingLastName}</span>}
            </div>
          </div>

          <div className="form-group">
            <label htmlFor="billingAddress">{t('checkout.address')} *</label>
            <input
              type="text"
              id="billingAddress"
              name="address"
              value={billingAddress.address}
              onChange={onBillingChange}
              className={errors.billingAddress ? 'error' : ''}
              placeholder={t('checkout.streetAddress')}
            />
            {errors.billingAddress && <span className="error-message">{errors.billingAddress}</span>}
          </div>

          <div className="form-group">
            <label htmlFor="billingApartment">{t('checkout.apartment')}</label>
            <input
              type="text"
              id="billingApartment"
              name="apartment"
              value={billingAddress.apartment}
              onChange={onBillingChange}
              placeholder={t('checkout.apartmentPlaceholder')}
            />
          </div>

          <div className="form-row">
            <div className="form-group">
              <label htmlFor="billingCity">{t('checkout.city')} *</label>
              <input
                type="text"
                id="billingCity"
                name="city"
                value={billingAddress.city}
                onChange={onBillingChange}
                className={errors.billingCity ? 'error' : ''}
                placeholder={t('checkout.enterCity')}
              />
              {errors.billingCity && <span className="error-message">{errors.billingCity}</span>}
            </div>
            <div className="form-group">
              <label htmlFor="billingZipCode">{t('checkout.zipCode')} *</label>
              <input
                type="text"
                id="billingZipCode"
                name="zipCode"
                value={billingAddress.zipCode}
                onChange={onBillingChange}
                className={errors.billingZipCode ? 'error' : ''}
                placeholder="1234567"
                maxLength={7}
              />
              {errors.billingZipCode && <span className="error-message">{errors.billingZipCode}</span>}
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default BillingSection;

